import { render, staticRenderFns } from "./PromoRealization.vue?vue&type=template&id=dbcc485c"
import script from "./PromoRealization.vue?vue&type=script&lang=js"
export * from "./PromoRealization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports